Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArraySorter = void 0;
var ArraySorter = exports.ArraySorter = function ArraySorter(item1, item2, field) {
  var order = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'asc';
  if (item1[field] > item2[field]) return order === 'asc' ? 1 : -1;
  if (item1[field] < item2[field]) return order === 'asc' ? -1 : 1;
  return 0;
};